import { Button } from 'antd';
import { type Dispatch, type SetStateAction, useState } from 'react';

import type { GroupData } from '@/features/user-management/interfaces/interfaces';

interface CreateGroupFormProps {
  groupData: GroupData;
  setGroupData: Dispatch<SetStateAction<GroupData>>;
  setActiveStep: Dispatch<SetStateAction<number>>;
}

export const CreateGroupForm = ({ groupData, setGroupData, setActiveStep }: CreateGroupFormProps) => {
  const [inputData, setInputData] = useState('');

  const handleSubmit = () => {
    setGroupData({
      ...groupData,
      groupName: inputData,
    });

    setActiveStep(2);
  };

  return (
    <>
      <div className="flex flex-grow gap-[25px] h-[72px] items-center">
        <input
          required
          className="w-[581px] h-14 rounded border p-2 border-[#D9D9D9] focus:!border-[#000000] focus:!ring-0 placeholder:text-[#808080]"
          name="groupName"
          pattern="^[A-Za-z][A-Za-z0-9_]*$"
          placeholder="Select a clear name for the group to make  it easy to identify."
          type="text"
          onChange={(e) => setInputData(e.target.value)}
        />

        <Button
          className={`w-[88px] h-[50px] text-white ${inputData.trim() === '' ? 'bg-[#A6A6A6]' : 'bg-primary-gold'} rounded-md flex items-center justify-center font-medium text-sm border-0`}
          disabled={inputData.trim() === ''}
          onClick={handleSubmit}
        >
          Next
        </Button>
      </div>

      <label className="w-full px-4 py-1 font-normal text-xs text-[#A9A9A9]">
        Start with a letter. Use only letters, numbers, and underscores. No spaces or symbols.
      </label>
    </>
  );
};
